import React, { useEffect, useState } from "react";
import Joinus from "../../common/Joinus";
import { accordionItemsfb, initialStates, servicesfb, gridcontent, socialMediaServiceDetails } from "../home/Constant";
import SocialFbAni from "./SocialFbAni";
import { AnimatePresence, motion } from "framer-motion";
import WhatWeDo from "./WhatWeDo";

const SocialFb = () => {
  const [showAll, setShowAll] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});
  const colors = ["#ffc250", "#e9536c", "#f4b1b8", "#1eacc0"];
  const toggleContent = (id) => {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      console.log(`Scr ${currentY.toFixed(0)}px`);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const itemsToShow = showAll ? accordionItemsfb : accordionItemsfb.slice(0, 8);


  return (
    <div className="margin-topall">
      <section className="py-5 service-position pytab overflow-hidden">
        <div className="container">
          <div className="metafb-bg-round">
            {colors.map((color, i) => (
              <div
                key={i}
                id={`dot_00${i}`}
                style={{
                  position: "absolute",
                  border: `${i == 0 ? "9px solid white" : "none"}`,
                  top: `${initialStates[i].top}px`,
                  left: `${initialStates[i].left}px`,
                  width: `${initialStates[i].width}px`,
                  height: `${initialStates[i].height}px`,
                  marginLeft: `${initialStates[i].marginLeft}px`,
                  opacity: initialStates[i].opacity,
                  backgroundColor: color,
                  borderRadius: "50%",
                  zIndex: 1000,
                  pointerEvents: "none",
                  willChange: "top, left, width, height, opacity, margin-left",
                }}
              />
            ))}
          </div>
          <div className="pos-z-index">
            <div className="row justify-content-center">
              <div className="col-lg-10 paddingfb"
                data-aos="fade-up" data-aos-delay="300"
              >
                <div className="">
                  <h5 className="yellow-sub-heading text-center py-2 ">
                    Social Media Marketing Services
                  </h5>
                  <div className="fbsocial-sub-heading">
                    Social media marketing services help businesses build a strong online presence,
                    connect with the right audience, and drive measurable growth through platforms
                    like Facebook and Instagram. With billions of active users, these platforms
                    offer powerful opportunities to promote your brand, generate leads,
                    and increase conversions through both organic content and paid advertising.
                    Our Facebook & Instagram - focused social media marketing services are designed
                    to be cost-effective, highly targeted, and performance-driven. Using advanced
                    audience targeting based on demographics, interests, and behaviors, we help
                    businesses reach people who are most likely to engage and convert.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WhatWeDo data={socialMediaServiceDetails} />
      <SocialFbAni />
      <section className="overflow-hidden">
        <div className="container">

          {gridcontent.map((item, index) => (
            <div className="row gridflex">
              <div className={`col-lg-6 ${index % 2 === 0 ? 'order-lg-1' : 'order-lg-2'}`}
                data-aos={`fade-${index % 2 === 1 ? "left" : "right"}`} data-aos-delay="300"
              >
                <div className="d-flex gap-2">
                  <div className="circleservice">{index + 1}</div>
                  <h1 className="servicebenefit">{item.heading}</h1>
                </div>
                <div className="servicefontb">
                  <p className=" py-2">{item.para1}</p>
                </div>
                {/* {expandedItems[index] && <p c className={`servicefontb expandable-content ${expandedItems[index] ? 'expanded' : ''}`}>{item.para2}</p>}
                <button className="btn-sm readbtn" onClick={() => toggleContent(index)}>
                  {expandedItems[index] ? 'Read Less' : 'Read More'}
                </button> */}
                <AnimatePresence initial={false}>
                  {expandedItems[index] && (
                    <motion.p
                      key="expand-content"
                      className="servicefontb"
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.4 }}
                    >
                      {item.para2}
                    </motion.p>
                  )}
                </AnimatePresence>

                <button className="btn-sm readbtn" onClick={() => toggleContent(index)}>
                  {expandedItems[index] ? "Read Less" : "Read More"}
                </button>
              </div>
              <div className={`col-lg-6 gridimage ${index % 2 === 0 ? 'order-lg-2' : 'order-lg-1'}`}
                data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`} data-aos-delay="300"
              >
                <img className="bulkwidth" src={item.img} alt={`Visual for ${item.heading}`} />
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* <WhatDo/> */}
      <section className="py-5 overflow-hidden">
        <div className="container">
          <div>
            <h1 className="py-2 faqfont mb-5">FAQs - (Facebook & Instagram)</h1>
          </div>
          <div className="accordion" id="accordionExample">
            {itemsToShow.map((item, index) => (
              <div className="accordion-item border-top" key={index}
                data-aos={`fade-${index % 2 === 1 ? "left" : "right"}`} data-aos-delay="300"
              >
                <h2 className="accordion-header" id={`heading${item.id}`}>
                  <button
                    className={`accordion-button d-flex align-items-center ${index !== 0 ? 'collapsed' : ''
                      }`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${item.id}`}
                    aria-expanded={index === 0 ? 'true' : 'false'}
                    aria-controls={`collapse${item.id}`}
                  >
                    <span className="me-3 toggle-icon"></span>
                    {item.question}
                  </button>
                </h2>
                <div
                  id={`collapse${item.id}`}
                  className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                  aria-labelledby={`heading${item.id}`}
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body wrapfaq">{item.answer}</div>
                </div>
              </div>
            ))}
          </div>
          {accordionItemsfb.length > 10 && (
            <div className="text-center py-3 ">
              <button
                className="btn-sm viewbtn"
                onClick={() => setShowAll(!showAll)}
              >
                {showAll ? "View Less" : "View More"}
              </button>
            </div>
          )}
        </div>
      </section>
      <Joinus />
    </div>
  );
};

export default SocialFb;
